import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiRequestService } from '@gelato-api-ui/core/api/services/api-request.service';
import { EStore } from '@gelato-api-ui/core/e-commerce/e-store';
import {
  StoreMetadataCreateRequest,
  StoreMetadataResponse,
  StoreMetadataSearchRequest,
  StoreMetadataUpdateRequest,
} from '@gelato-api-ui/core/e-commerce/types/e-commerce-store-metadata-types';

@Injectable({
  providedIn: 'root',
})
export class ECommerceStoreMetadataApiService {
  constructor(private readonly apiRequest: ApiRequestService) {}

  get(request: StoreMetadataSearchRequest, storeId?: string): Observable<StoreMetadataResponse> {
    const id = storeId || '*';

    return this.apiRequest
      .get<StoreMetadataResponse>(`api/ecommerce/v1/stores/${id}/metadata`, { body: request })
      .pipe(map(data => data.data));
  }

  create(storeId: string, request: StoreMetadataCreateRequest): Observable<StoreMetadataResponse> {
    return this.apiRequest
      .post<StoreMetadataResponse>(`api/ecommerce/v1/stores/${storeId}/metadata`, { body: request })
      .pipe(map(data => data.data));
  }

  update(storeId: string, request: StoreMetadataUpdateRequest): Observable<StoreMetadataResponse> {
    return this.apiRequest
      .put<StoreMetadataResponse>(`api/ecommerce/v1/stores/${storeId}/metadata`, {
        body: request,
      })
      .pipe(map(data => data.data));
  }

  delete(storeId: string): Observable<EStore> {
    return this.apiRequest.delete<EStore>(`/v1/ecommerce/stores/${storeId}/metadata`).pipe(map(data => data.data));
  }
}
